export function replaceSpaceByDash(str: string) {
  return str.replace(/\s/g, '_');
}
export const compressImage = (img: HTMLImageElement, fileType: string, name: string, callback: Function) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (img.width > 1024 || img.height > 1024) {
    const scale = Math.min(1024 / img.width, 1024 / img.height);
    canvas.width = img.width * scale;
    canvas.height = img.height * scale;
  } else {
    canvas.width = img.width;
    canvas.height = img.height;
  }

  ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

  canvas.toBlob(
    (blob) => {
      const compressedFile = new File(
        [blob as BlobPart],
        `${name.split('.')[0]}.${fileType.split('/')[1]}`,
        {
          type: fileType,
          lastModified: Date.now(),
        },
      );
      callback(compressedFile);
    },
    fileType,
    0.7,
  );
}


// WEBPACK FOOTER //
// ./src/utils/helpers.ts